import type { FunctionComponent } from 'react';
import styles from './VulnerabilitiesDrawer.module.less';

/**
 * VulnerabilityDrawerSection is just to wrap each section
 * and provide uniform vertical spacing for each.
 */
const VulnerabilityDrawerSection: FunctionComponent = ({ children }) => (
  <section className={styles.section}>
    {children}
  </section>
);

export default VulnerabilityDrawerSection;
